import { FC, useEffect, useState } from 'react';
import { Field } from 'formik';
import { CustomSelectFormik, IOption } from 'components/elements';
import { PAGINATION_LIMIT } from 'utils/constants';
import { ProvidersService } from 'utils/services';
import s from '../index.module.scss';

export const ProviderSelect: FC = () => {
	const [providerOptions, setProviderOptions] = useState<IOption[]>([]);

	useEffect(() => {
		handleGetProviderOptions();
	}, []);

	const handleGetProviderOptions = async () => {
		try {
			const { data } = await ProvidersService.getProviders({
				pagination: {
					offset: 0,
					limit: PAGINATION_LIMIT.BIG,
				},
			});
			setProviderOptions(
				data.results.reduce((acc, result) => {
					const title = result.provider;

					if (!title) {
						return acc;
					}
					return [...acc, { value: title, title }];
				}, [] as IOption[])
			);
		} catch (error) {
			console.error('Error during getting providers', error);
		}
	};

	return (
		<Field
			className={s.select}
			name="provider"
			placeholder="Партнери"
			options={providerOptions}
			component={CustomSelectFormik}
			multiple
		/>
	);
};
